import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Manager } from '../models/manager.model';
import { plainToInstance } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ManagerService {

  private apiUrl = `${environment.sgcApi}`;
  private managerRoute = 'manager';

  constructor(
    private httpClient: HttpClient
  ) {}

  getManagersMap(): Observable<Manager[]> {
    let endpoint = `${this.apiUrl}${this.managerRoute}/map`;
    return this.httpClient.get<Manager[]>(endpoint).pipe(map((managers) => {
      return plainToInstance(Manager, managers as Manager[]);
    }));
  }
}
